import { gql } from 'graphql-request';

const query = gql`
  query ownerRoyalties($where: RoyaltyWhereInput) {
    royaltiesConnection(where: $where) {
      edges {
        node {
          id
          date
        }
      }
    }
  }
`

export default query;
